import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { fetchRates, fetchGold, formatNum } from "../lib/api";

export default function MarqueeTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const [rates, gold] = await Promise.all([fetchRates(), fetchGold()]);
        const top = rates.rates.filter((r) =>
          ["USD", "EUR", "GBP", "CHF", "JPY", "CAD", "AUD", "SAR", "AED"].includes(r.code),
        );
        const goldGram = gold.items.find((g) => g.code === "GRAM");
        const goldCeyrek = gold.items.find((g) => g.code === "CEYREK");
        const goldTam = gold.items.find((g) => g.code === "TAM");
        const list = [
          ...top.map((r) => ({
            label: `${r.flag || ""} ${r.code}/TRY`,
            buy: r.forex_buying,
            sell: r.forex_selling,
            unit: r.unit,
          })),
          goldGram && {
            label: "🥇 GRAM ALTIN",
            buy: goldGram.buy,
            sell: goldGram.sell,
            unit: 1,
          },
          goldCeyrek && {
            label: "🥇 ÇEYREK",
            buy: goldCeyrek.buy,
            sell: goldCeyrek.sell,
            unit: 1,
          },
          goldTam && {
            label: "🥇 TAM ALTIN",
            buy: goldTam.buy,
            sell: goldTam.sell,
            unit: 1,
          },
        ].filter(Boolean);
        setItems(list);
      } catch (e) {
        // silent
      }
    };
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);

  if (!items.length) {
    return (
      <div className="bg-slate-950 text-slate-400 text-xs py-2 px-6 flex items-center gap-3">
        <span className="live-dot" /> Canlı kurlar yükleniyor...
      </div>
    );
  }

  return (
    <div className="bg-slate-950 text-white border-b border-white/5" data-testid="marquee-ticker">
      <div className="flex items-center">
        <div className="hidden sm:flex items-center gap-2 px-5 py-3 bg-brand-gold/15 text-brand-gold border-r border-white/5 shrink-0">
          <span className="live-dot" />
          <span className="text-[11px] font-semibold tracking-[0.2em] uppercase">Canlı Piyasalar</span>
        </div>
        <Marquee speed={45} gradient={false} pauseOnHover className="py-3">
          {items.map((it, i) => {
            const unitLabel = it.unit && it.unit !== 1 ? ` (${it.unit})` : "";
            return (
              <span key={i} className="flex items-center gap-3 px-7 text-sm">
                <span className="text-slate-300 font-medium">{it.label}{unitLabel}</span>
                <span className="font-mono-fin text-finance-up">{formatNum(it.buy, 4)}</span>
                <span className="text-slate-600">·</span>
                <span className="font-mono-fin text-rose-300">{formatNum(it.sell, 4)}</span>
                <span className="text-slate-700">|</span>
              </span>
            );
          })}
        </Marquee>
      </div>
    </div>
  );
}
